import { Injectable, WritableSignal } from '@angular/core';

import { AlertController } from '@ionic/angular';

import { ApiService } from '@core/services/api/api.service';
import { AppSettingsService } from '@core/services/app-settings/app-settings.service';
import { ProductsService } from '@core/services/products/products.service';

import { BaseProfileCommand } from '@shared/commands/base-profile.command';
import { IProfileCommandContext } from '@shared/models/profile-command.model';
import { AuthService } from '@shared/services/auth.service';
import { CommandAvailabilityService } from '@shared/services/command-availability.service';

@Injectable()
export class BlockUserCommand extends BaseProfileCommand {
  readonly type = 'blockUser';
  readonly title = 'Заблокировать себя';
  readonly subtitle?: WritableSignal<string> = undefined;
  readonly icon = 'lock';
  readonly checkbox?: 'unchecked' | 'checked' | 'disabled' | null = null;
  readonly hidden = false;
  readonly group = 'main';
  readonly order = 4;
  readonly settingsNames?: string[] = undefined;

  constructor(
    private alertController: AlertController,
    private apiService: ApiService,
    private authService: AuthService,
    private productsService: ProductsService,
    commandAvailabilityService?: CommandAvailabilityService,
    appSettingsService?: AppSettingsService
  ) {
    super(commandAvailabilityService, appSettingsService);
  }

  async execute(_context: IProfileCommandContext): Promise<void> {
    const alert = await this.alertController.create({
      header: 'Заблокировать себя',
      message: 'Вы уверены, что хотите заблокировать себя?',
      cssClass: 'inverted-accent',
      inputs: [
        {
          name: 'text',
          placeholder: 'Причина блокировки',
          type: 'text'
        }
      ],
      buttons: [
        {
          text: 'Отмена',
          role: 'cancel'
        },
        {
          text: 'Заблокировать',
          handler: (data) => {
            this.blockUser(data.text as string);
          }
        }
      ],
      backdropDismiss: false
    });

    await alert.present();
  }

  private blockUser(blockReason: string): void {
    this.apiService.post('rest/personal/user/block', { blockReason }).subscribe(() => this.resetPin());
  }

  private resetPin(): void {
    /**
     * TODO
     * Функционал не реализован, перекидывает на логин
     * При переходе на пин, рассыпается приложение (запрос настроек пина не проходит)
     * Требуется отдельная задача на разработку
     */
    this.productsService.refreshProducts$.next(true);
    this.authService.setIsAuthorized(false);
    this.authService.clearAuthData().then(() => {
      ApiService.errorResponse = undefined;
    });
  }
}
